import { Component, Input } from '@angular/core';
import { IngestionRow } from '../landing-dashboard/landing-dashboard.component';
import { EChartsOption, graphic } from 'echarts';
import { DashboardService } from '../../../../services/dashboard/dashboard.service';
import { AppService } from '../../../../app.service';
import moment from 'moment';
import { catchError, finalize, tap } from 'rxjs';
import { getGraphHeight } from '../../helpers/data-helper';
import { isArrayWithData } from '../../../../utilities/array.helpers';
import { SelectOptionLabelValue } from '../../../../interfaces/select-option.interface';

@Component({
    selector: 'import-ingestions-dashboard',
    templateUrl: './import-ingestions-dashboard.component.html',
    styleUrl: './import-ingestions-dashboard.component.css',
})
export class ImportIngestionsDashboardComponent {
    constructor(
        private dashboardService: DashboardService,
        public appService: AppService,
    ) {}

    getGraphHeight = getGraphHeight;
    isArrayWithData = isArrayWithData;
    @Input() creditors!: any[];
    @Input() timezones!: any[];
    todaysDate = new Date();

    selectedCreditors?: number[];
    creditorsYAxisImportIngestions?: string[];
    fromDate: Date = new Date();
    toDate: Date = new Date();
    statuses: SelectOptionLabelValue[] = [
        {
            value: 0,
            label: 'Success',
        },
        {
            value: 1,
            label: 'Warning',
        },
        {
            value: 2,
            label: 'Failed',
        },
    ];
    selectedStatuses: number[] = [];
    // this.statusesImportIngestions.map(
    //     (i: SelectOptionLabelValue) => i.value,
    // );
    selectedTimezone?: string;

    chartOptions!: EChartsOption;
    rows: IngestionRow[] = [];
    totals: any;

    ngOnInit() {
        this.getGraph();
    }

    getGraph() {
        this.appService.isShowPageSpinner = true;
        this.dashboardService
            .getTableImportIngestions(
                moment(this.fromDate).format('YYYY-MM-DD'),
                moment(this.toDate).format('YYYY-MM-DD'),
                this.selectedCreditors?.map((i: any) => i.value),
                this.selectedTimezone,
                this.selectedStatuses,
            )
            .pipe(
                tap((res: any) => {
                    console.log('Graph Import Ingestions res:', res);
                    this.generateGraphImportIngestions(res);
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    }

    generateGraphImportIngestions(apiResponse: any) {
        this.rows = apiResponse?.data;

        this.totals = this.rows.reduce(
            (a, b) => ({
                totalRecords: a.totalRecords + b.totalRecords,
                invoices: a.invoices + b.invoices,
                contacts: a.contacts + b.contacts,
                voided: a.voided + b.voided,
            }),
            { totalRecords: 0, invoices: 0, contacts: 0, voided: 0 },
        );

        this.totals.voidedRate =
            this.totals.totalRecords > 0
                ? Number(
                      (this.totals.voided / this.totals.totalRecords) * 100,
                  ).toFixed(2)
                : 0;

        // const summary = apiResponse?.summary;

        // this.chartOptionsImportIngestions = {
        //     tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },

        //     legend: {
        //         top: 10,
        //         left: 'center',
        //         itemWidth: 14,
        //         itemHeight: 14,
        //     },

        //     grid: { left: 50, right: 20, bottom: 40, top: 60 },

        //     xAxis: {
        //         type: 'category',
        //         data: summary.map((i: any) => moment(i.date).format('MMM DD')),
        //         axisTick: { show: false },
        //         axisLine: { lineStyle: { color: '#9ca3af' } },
        //     },

        //     yAxis: {
        //         type: 'value',
        //         axisLine: { show: false },
        //         splitLine: { lineStyle: { type: 'dashed', color: '#e5e7eb' } },
        //     },

        //     series: [
        //         {
        //             name: 'Invoices',
        //             type: 'bar',
        //             stack: 'total',
        //             barWidth: 150,
        //             itemStyle: {
        //                 color: new graphic.LinearGradient(0, 0, 0, 1, [
        //                     { offset: 0, color: '#2563eb' },
        //                     { offset: 1, color: '#93c5fd' },
        //                 ]),
        //             },
        //             data: summary.map((i: any) => i.invoices),
        //         },
        //         {
        //             name: 'Contacts',
        //             type: 'bar',
        //             stack: 'total',
        //             barWidth: 150,
        //             itemStyle: {
        //                 color: new graphic.LinearGradient(0, 0, 0, 1, [
        //                     { offset: 0, color: '#60a5fa' },
        //                     { offset: 1, color: '#bfdbfe' },
        //                 ]),
        //             },
        //             data: summary.map((i: any) => i.contacts),
        //         },
        //         {
        //             name: 'Voided Invoices',
        //             type: 'bar',
        //             stack: 'total',
        //             barWidth: 150,
        //             itemStyle: {
        //                 color: new graphic.LinearGradient(0, 0, 0, 1, [
        //                     { offset: 0, color: '#ef4444' },
        //                     { offset: 1, color: '#fecaca' },
        //                 ]),
        //             },
        //             data: summary.map((i: any) => i.voided),
        //         },
        //     ],
        // };
    }

    getVoidedRateProgress(voidedRate: string) {
        return parseInt(voidedRate.replace('%', ''));
    }

    getRecordsProgress(totalRecords: number) {
        return (totalRecords / this.totals?.totalRecords) * 100;
    }

    getInvoicesProgress(r: any) {
        return (r.invoices / r.totalRecords) * 100;
    }

    getContactsProgress(r: any) {
        return (r.contacts / r.totalRecords) * 100;
    }

    setupGraphImportIngestionsMock() {
        const apiResponse = [
            {
                date: 'Nov 24',
                invoices: 130000,
                contacts: 85000,
                voidedInvoices: 12000,
            },
            {
                date: 'Nov 24',
                invoices: 130000,
                contacts: 85000,
                voidedInvoices: 12000,
            },
            {
                date: 'Nov 24',
                invoices: 130000,
                contacts: 85000,
                voidedInvoices: 12000,
            },
        ];

        this.chartOptions = {
            tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },

            legend: {
                top: 10,
                left: 'center',
                itemWidth: 14,
                itemHeight: 14,
            },

            grid: { left: 50, right: 20, bottom: 40, top: 60 },

            xAxis: {
                type: 'category',
                data: apiResponse.map((i: any) => i.date),
                axisTick: { show: false },
                axisLine: { lineStyle: { color: '#9ca3af' } },
            },

            yAxis: {
                type: 'value',
                axisLine: { show: false },
                splitLine: { lineStyle: { type: 'dashed', color: '#e5e7eb' } },
            },

            series: [
                {
                    name: 'Invoices',
                    type: 'bar',
                    stack: 'total',
                    barWidth: 150,
                    itemStyle: {
                        color: new graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: '#2563eb' },
                            { offset: 1, color: '#93c5fd' },
                        ]),
                    },
                    data: apiResponse.map((i: any) => i.invoices),
                },
                {
                    name: 'Contacts',
                    type: 'bar',
                    stack: 'total',
                    barWidth: 150,
                    itemStyle: {
                        color: new graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: '#60a5fa' },
                            { offset: 1, color: '#bfdbfe' },
                        ]),
                    },
                    data: apiResponse.map((i: any) => i.contacts),
                },
                {
                    name: 'Voided Invoices',
                    type: 'bar',
                    stack: 'total',
                    barWidth: 150,
                    itemStyle: {
                        color: new graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: '#ef4444' },
                            { offset: 1, color: '#fecaca' },
                        ]),
                    },
                    data: apiResponse.map((i: any) => i.voidedInvoices),
                },
            ],
        };

        this.rows = [
            {
                status: 'Success',
                id: 166,
                file: 'si_acima_accounts.csv',
                start: new Date(),
                totalRecords: 39446,
                invoices: 39446,
                contacts: 39597,
                voided: 419,
                voidedRate: 1,
            },

            {
                status: 'Failed',
                id: 215,
                file: 'ACC_REMITTER.csv',
                start: new Date(),
                totalRecords: 77926,
                invoices: 77926,
                contacts: 189,
                voided: 978,
                voidedRate: 3,
            },
        ];

        this.totals = this.rows.reduce(
            (a, b) => ({
                totalRecords: a.totalRecords + b.totalRecords,
                invoices: a.invoices + b.invoices,
                contacts: a.contacts + b.contacts,
                voided: a.voided + b.voided,
                voidedRate: Math.round(
                    ((a.voided + b.voided) /
                        (a.totalRecords + b.totalRecords)) *
                        100,
                ),
            }),
            {
                totalRecords: 0,
                invoices: 0,
                contacts: 0,
                voided: 0,
                voidedRate: 0,
            },
        );
    }

    onGenerateImportIngestions() {}

    onChangeCreditor(event: any) {}
    onChangeStatuses(event: any) {}
}
